var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{style:(_vm.getAnchorStyle()),attrs:{"href":_vm.getLink(),"target":_vm.getTarget()}},[_c('img',{class:this.classname,attrs:{"src":this.imgsrc}}),_c('span',[_c('div',[_vm._v(_vm._s(this.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }